/** Canonical integration scopes (Forms embed + JSON gateway v1). */
export const FORMS_INTEGRATION_SCOPES = [
  'forms.schemas:read',
  'forms.submissions:read',
  'forms.submissions:write',
  'forms.submissions:delete',
  'forms.audit:read'
] as const

export type FormsIntegrationScope = (typeof FORMS_INTEGRATION_SCOPES)[number]

export const DEFAULT_PUBLISHABLE_SCOPES: FormsIntegrationScope[] = [
  'forms.schemas:read',
  'forms.submissions:read',
  'forms.submissions:write'
]

export interface IntegrationCredentialRow {
  id: string
  name: string
  key_prefix: string
  credential_type: 'publishable' | 'secret'
  environment: 'live' | 'test'
  allowed_origins: string[]
  scopes: string[]
  revoked_at: string | null
  last_used_at: string | null
  created_at: string
}

export interface CreateCredentialResult {
  credential_id: string
  key: string
  key_prefix: string
  credential_type: string
  environment: string
  scopes: string[]
  allowed_origins: string[]
  message: string
}

export interface IntegrationApiLogRow {
  id: string
  operation: string
  status_code: number | null
  success: boolean
  duration_ms: number | null
  origin: string | null
  error_code: string | null
  created_at: string
  credential_id: string | null
}
